/**
 * Generic transformer for user data
 * - Converts ISO date strings to dd/mm/yyyy
 * - Maps userType and status fields to readable values
 * @param {Array<Object>} data - Array of user records
 * @returns {Array<Object>} - Transformed user data
 */
function transformUserData(data) {
  const formatDate = (isoString) => {
    if (!isoString) return null;
    const date = new Date(isoString);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  };

  const userTypeMap = {
    SUPER_ADMIN: 'Super Admin',
    TENANT_ADMIN: 'Tenant Admin',
    PARTNER_ADMIN: 'Partner Admin',
    TENANT_USER: 'Tenant User',
    PARTNER_USER: 'Partner User',
    SUPPORT_TEAM: 'Support Team',
    TEMP_USER: 'Temporary User',
  };

  const statusMap = {
    active: '✅ Active',
    inactive: '🚫 Inactive',
    pending: '⏳ Pending Approval',
  };

  return data.map((item) => {
    const transformed = { ...item };

    // Format all date fields
    for (const key in transformed) {
      if (
        transformed[key] &&
        typeof transformed[key] === 'string' &&
        /^\d{4}-\d{2}-\d{2}T/.test(transformed[key])
      ) {
        transformed[key] = formatDate(transformed[key]);
      }
    }

    // Map userType
    if (transformed.userType && userTypeMap[transformed.userType]) {
      transformed.userType = userTypeMap[transformed.userType];
    }

    // Map status
    if (transformed.status && statusMap[transformed.status]) {
      transformed.status = statusMap[transformed.status];
    }

    return transformed;
  });
}

// ✅ ES6 default export
export default transformUserData;
